import React, { useState } from 'react';
import BulkUploadNew from './components/BulkUploadNew';
import BulkUpdateMeetGreet from './components/BulkUpdateMeetGreet';
import BulkUploadNotAttended from './components/BulkUploadNotAttended';
import BulkUploadResults from './components/BulkUploadResults';
import BulkUploadRegisteredSW from './components/BulkUploadRegisteredSW';

const BulkUpload = () => {
  const [result, setResult] = useState(null);
  const [resultType, setResultType] = useState(null);

  const handleResult = (data, type) => {
    setResult(data);
    setResultType(type);
  };

  return (
    <div className="bulk-page">
      <h2 className="mb-4">Bulk Upload / Edit Applicants</h2>
      <div className="bulk-grid">
        <BulkUpdateMeetGreet onResult={handleResult} />
        <BulkUploadNew onResult={handleResult} />
      </div>
      <BulkUploadRegisteredSW onResult={handleResult} />
      <BulkUploadResults result={result} type={resultType} />

      <style jsx>{`
        .bulk-page {
          padding: 8px 0;
        }

        .bulk-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
        }

        @media (min-width: 992px) {
          .bulk-grid {
            grid-template-columns: 1fr 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default BulkUpload;